(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(59154);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ RedButton; }
/* harmony export */ });
/* unused harmony export WhiteButton */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #f1f1f1;\n    gap: 10px;\n    border-radius: 5px;\n    color: #000000;\n    font-size: 1.1rem;\n    font-weight: 400;\n    height: ",
        ";\n    width: ",
        ";\n    max-width: ",
        ";\n    box-shadow: 0 4px 4px 0 #ffffff30;\n    background-position: center;\n    border: 1px solid transparent; /* Add this line */\n\n    cursor: pointer;\n    &:hover{\n       border-color: #f1f1f1;\n       color: #f1f1f1;\n       transition: 0.2s linear;\n       background: #0a0a0a radial-gradient(circle, transparent 1%, #f1f1f120 1%) center/15000%;\n    }\n\n\n    &:active {\n        background-color: #f1f1f120;\n        background-size: 100%;\n        transition: background 0s;\n    }\n\n\n    @media screen and (max-width:600px) {\n      font-size: 1.2rem;\n      height: ",
        ";\n      width: ",
        ";\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(26,26,26,0.6);\n    border: 2px solid #ff4d5a;\n    border-radius: 5px;\n    color: #f1f1f1;\n    font-size: 1.1rem;\n    font-weight: 400;\n    //width: 135px;\n    height:42px;\n    width: ",
        ";\n    max-width: ",
        ";\n    gap:10px;\n    background: linear-gradient(55deg,  #ff4d5a 50%, #ffffff00 50%) right;\n    background-size: 300%;\n    transition: .6s ease-out;\n\n  &:hover {\n    cursor: pointer;\n    scale: 1.02;\n    background-position: left;\n  }\n\n    @media screen and (max-width:600px) {\n      width: 180px;\n      font-size: 1.2rem;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var WhiteButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-91166402-0"
})(_templateObject(), function(props) {
    return props.height;
}, function(props) {
    return props.width;
}, function(props) {
    return props.maxWidth;
}, function(props) {
    return props.heightMobile;
}, function(props) {
    return props.widthMobile;
});
var RedButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-91166402-1"
})(_templateObject1(), function(props) {
    return props.width;
}, function(props) {
    return props.maxWidth;
});


/***/ }),

/***/ 49516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ delay; }
/* harmony export */ });
function delay(delay) {
    return new Promise(function(res) {
        return setTimeout(res, delay);
    });
}


/***/ }),

/***/ 59154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./Layout/Layout.js + 11 modules
var Layout = __webpack_require__(98342);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/firebase/firestore/dist/esm/index.esm.js + 2 modules
var index_esm = __webpack_require__(36100);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./components/utils/firebase/firebase.js + 5 modules
var firebase = __webpack_require__(81229);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Visibility.js
var Visibility = __webpack_require__(22961);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/VisibilityOff.js
var VisibilityOff = __webpack_require__(72450);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 5 modules
var Alert = __webpack_require__(46901);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 3 modules
var InputLabel = __webpack_require__(33841);
// EXTERNAL MODULE: ./node_modules/@mui/material/OutlinedInput/OutlinedInput.js + 1 modules
var OutlinedInput = __webpack_require__(57709);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 14 modules
var createTheme = __webpack_require__(21265);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js + 5 modules
var ThemeProvider = __webpack_require__(22430);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(61903);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 111 modules
var motion = __webpack_require__(21121);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var bi_index_esm = __webpack_require__(47516);
// EXTERNAL MODULE: ./context/languageContext.js
var languageContext = __webpack_require__(34579);
// EXTERNAL MODULE: ./components/utils/reuseable/delay.js
var delay = __webpack_require__(49516);
;// CONCATENATED MODULE: ./components/loginPage/components/textAnimation.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n   color: #FFFFFF;\n   font-size: 34px;\n   text-align: center;\n   font-weight: 500;\n   width: 100%;\n   height: auto;\n   padding-bottom: 12px;\n   line-height: 40px;\n   @media screen and (max-width:600px) {\n    font-size: 2rem;\n    line-height: 2.2rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 12px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




//Text Animation
var LargeText = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.span */.E.span).withConfig({
    componentId: "sc-b75a1f53-0"
})(_templateObject());
var TextBox = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.span */.E.span).withConfig({
    componentId: "sc-b75a1f53-1"
})(_templateObject1());
function TextAnimation(param) {
    var line1 = param.line1;
    var sentance = {
        hidden: {
            opacity: 1
        },
        visable: {
            opacity: 1,
            transition: {
                delay: 0.5,
                staggerChildren: 0.1
            }
        }
    };
    var letter = {
        hidden: {
            opacity: 0,
            y: 50
        },
        visable: {
            opacity: 1,
            y: 0
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBox, {
        variants: sentance,
        initial: "hidden",
        animate: "visable",
        children: line1 ? line1.split("").map(function(char, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LargeText, {
                variants: letter,
                children: char
            }, char + "" + index);
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
}
/* harmony default export */ var textAnimation = (TextAnimation);

// EXTERNAL MODULE: ./components/utils/reuseable/SxProps.js
var SxProps = __webpack_require__(43759);
// EXTERNAL MODULE: ./components/utils/reuseable/buttons.js
var buttons = __webpack_require__(49757);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/loginPage/components/loginComponent.js



function loginComponent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 400px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    width:500px;\n    gap:12px;\n\n    @media screen and (max-width:600px) {\n        width:300px;\n      font-size: 1.2rem;\n    }\n   \n"
    ]);
    loginComponent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function loginComponent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  height: 20px;\n  color: #f1f1f199;\n  font-size: 0.9rem;\n"
    ]);
    loginComponent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n  gap: 10px;\n  height: fit-content;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 90%;\n  border-bottom: 1px solid #333D4A;\n  margin-bottom: 10px;\n\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
























var theme = (0,createTheme/* default */.Z)({
    breakpoints: {
        values: {
            mobile: 0,
            desktop: 450
        }
    }
});
var AnimatePassword = {
    hidden: {
        opacity: 1,
        y: 0
    },
    visable: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 1,
            delay: 0.5
        }
    }
};
var OuterDiv = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.div */.E.div).withConfig({
    componentId: "sc-116ea204-0"
})(loginComponent_templateObject());
var TextWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-116ea204-1"
})(loginComponent_templateObject1());
var BottomWrap = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.div */.E.div).withConfig({
    componentId: "sc-116ea204-2"
})(_templateObject2());
var TextDiv = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.div */.E.div).withConfig({
    componentId: "sc-116ea204-3"
})(_templateObject3());
var sxPassword = {
    //When focused
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#ff4d5a"
    },
    //When not in focus
    "& .MuiOutlinedInput-notchedOutline": {
        border: "0.5px solid #888BA3"
    },
    backgroundColor: "rgba(230, 232, 250, 0.07)",
    color: "white"
};
function LandingComponent(param) {
    var users = param.users, userEmails = param.userEmails;
    var handleKeypress = function handleKeypress(e) {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            handleSubmit(e);
        }
    };
    var ref = (0,react.useState)(""), userEmail = ref[0], setUserEmail = ref[1];
    var ref1 = (0,react.useState)(false), alert = ref1[0], setAlert = ref1[1];
    var ref2 = (0,react.useState)({
        message: "",
        status: ""
    }), alertProps = ref2[0], setAlertProps = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(true), hidden = ref4[0], setHidden = ref4[1];
    var ref5 = (0,react.useState)(false), showPassword = ref5[0], setShowPassword = ref5[1];
    var ref6 = (0,react.useState)(), user = ref6[0], setUser = ref6[1];
    var ref7 = (0,react.useState)(""), password = ref7[0], setPassword = ref7[1];
    var language = (0,react.useContext)(languageContext/* default */.Z).language;
    var history = (0,router.useRouter)();
    ////console.log(`signed in as ${currentUser?.uid}`)
    var handleClickShowPassword = function() {
        return setShowPassword(function(show) {
            return !show;
        });
    };
    var handleMouseDownPassword = function(event) {
        event.preventDefault();
    };
    (0,react.useEffect)(function() {
        if (userEmail.includes("@") && userEmail.includes(".")) {
            if (userEmails.includes(userEmail)) {
                setHidden(false);
                setUser(users.find(function(obj) {
                    return obj.email == userEmail;
                }));
            } else {
                setHidden(true);
                setUser({});
            }
        } else {
            setHidden(true);
            setUser({});
        }
    }, [
        userEmail
    ]);
    function handleSubmit(event) {
        return _handleSubmit.apply(this, arguments);
    }
    function _handleSubmit() {
        _handleSubmit = (0,_async_to_generator/* default */.Z)(function(event) {
            var ref, userLogin, uid, client, access;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        setLoading(true);
                        if (!!hidden) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            (0,firebase/* loginUser */.pH)(user.email, password)
                        ];
                    case 1:
                        userLogin = _state.sent();
                        setLoading(true);
                        uid = userLogin === null || userLogin === void 0 ? void 0 : (ref = userLogin.user) === null || ref === void 0 ? void 0 : ref.uid;
                        if (!(userLogin.status == "success" && uid)) return [
                            3,
                            2
                        ];
                        client = uid === null || uid === void 0 ? void 0 : uid.split("-")[0];
                        access = uid === null || uid === void 0 ? void 0 : uid.split("-")[1];
                        if (access == "admin") {
                            history.push("/".concat(client, "/").concat(access));
                        } else {
                            history.push("/".concat(client));
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            manageAlert(userLogin)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSubmit.apply(this, arguments);
    }
    ;
    function manageAlert(prop) {
        return _manageAlert.apply(this, arguments);
    }
    function _manageAlert() {
        _manageAlert = (0,_async_to_generator/* default */.Z)(function(prop) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setAlertProps({
                            message: prop.message,
                            status: prop.status
                        });
                        setAlert(true);
                        return [
                            4,
                            (0,delay/* default */.Z)(2000)
                        ];
                    case 1:
                        _state.sent();
                        setAlert(false);
                        setAlertProps({
                            message: "",
                            status: ""
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _manageAlert.apply(this, arguments);
    }
    // 
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
        theme: theme,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OuterDiv, {
            children: [
                alert ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                        severity: alertProps.status,
                        variant: "outlined",
                        sx: {
                            color: "white",
                            width: "90%",
                            mb: 2
                        },
                        children: alertProps.message
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TextDiv, {
                    children: hidden ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LargeText, {
                        children: language == "swe" ? "Ange din email" : "Input your email"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(textAnimation, {
                        line1: user ? user.name : "No user found"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                    autoFocus: true,
                    fullWidth: true,
                    label: language == "swe" ? "email" : "email",
                    sx: SxProps/* sxPropLanding */.Kd,
                    type: "email",
                    inputProps: {
                        maxLength: 40
                    },
                    value: userEmail,
                    onKeyDown: function(e) {
                        return handleKeypress(e);
                    },
                    onChange: function(e) {
                        return setUserEmail(e.target.value);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomWrap, {
                    variants: AnimatePassword,
                    initial: "hidden",
                    animate: "visable",
                    children: hidden ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomWrap, {
                        variants: AnimatePassword,
                        initial: "hidden",
                        animate: "visable",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                sx: {
                                    m: 1
                                },
                                variant: "outlined",
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                        htmlFor: "outlined-adornment-password",
                                        sx: {
                                            color: "#878A9D",
                                            "&.Mui-focused": {
                                                color: "#F9F7F5"
                                            }
                                        },
                                        children: "Password"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlinedInput/* default */.Z, {
                                        sx: sxPassword,
                                        id: "outlined-adornment-password",
                                        type: showPassword ? "text" : "password",
                                        autoComplete: "off",
                                        endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                            position: "end",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                "aria-label": "toggle password visibility",
                                                onClick: handleClickShowPassword,
                                                onMouseDown: handleMouseDownPassword,
                                                edge: "end",
                                                children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {
                                                    sx: {
                                                        color: "white"
                                                    }
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {
                                                    sx: {
                                                        color: "#ffffff99"
                                                    }
                                                })
                                            })
                                        }),
                                        label: language == "swe" ? "L\xf6senord" : "Password",
                                        value: password,
                                        onKeyDown: function(e) {
                                            return handleKeypress(e);
                                        },
                                        onChange: function(e) {
                                            return setPassword(e.target.value);
                                        },
                                        autoFocus: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(buttons/* RedButton */.Q, {
                                width: "50%",
                                onClick: handleSubmit,
                                children: [
                                    language == "swe" ? "Forts\xe4tt" : "Continue",
                                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                        style: {
                                            height: 18,
                                            width: 18,
                                            color: "#ffffff"
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(bi_index_esm/* BiRightArrowAlt */.OEZ, {
                                        style: {
                                            fill: "#FF4D59"
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextWrap, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            id: "modal-modal-title",
                            sx: {
                                color: "inherit",
                                fontSize: "inherit",
                                textAlign: "center",
                                p: 0,
                                width: "100%"
                            },
                            children: language == "swe" ? "Fr\xe5gor?" : "Questions?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            type: "a",
                            id: "modal-modal-title",
                            sx: {
                                color: "inherit",
                                textDecorationLine: "underline",
                                whiteSpace: "nowrap",
                                fontSize: "inherit",
                                textAlign: "center",
                                p: 0
                            },
                            children: language == "swe" ? " Kontakta mig" : " Contact me"
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/loginPage/index.js

function loginPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content:center;\n  align-items:center;\n  width:100%;\n  height:100vh;\n  @media screen and (max-width:800px) {\n    justify-content:center;\n    }\n"
    ]);
    loginPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function loginPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    height:400px;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center; // used to be top\n    gap:40px;\n"
    ]);
    loginPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var loginPage_OuterDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5409d65-0"
})(loginPage_templateObject());
var InnerDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5409d65-1"
})(loginPage_templateObject1());
function LoginPage() {
    var ref = (0,react.useState)([]), users = ref[0], setUsers = ref[1];
    var ref1 = (0,react.useState)([]), userEmails = ref1[0], setUserEmails = ref1[1];
    (0,react.useEffect)(function() {
        var q = (0,index_esm/* collection */.hJ)(firebase.db, "users");
        var unsub = (0,index_esm/* onSnapshot */.cf)(q, function(querySnapshot) {
            setUsers(querySnapshot.docs.map(function(doc) {
                return doc.data();
            }));
            setUserEmails(querySnapshot.docs.map(function(doc) {
                return doc.data().email;
            }));
        });
        return function() {
            return unsub;
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(loginPage_OuterDiv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerDiv, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingComponent, {
                users: users,
                userEmails: userEmails
            })
        })
    });
}

;// CONCATENATED MODULE: ./pages/index.js




function Home() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginPage, {})
    });
}
Home.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        children: page
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [13,874,207,121,631,292,172,342,774,888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);